<template>
    <div class="bg-cover rounded-lg"
        :class="{
            'w-32 h-48': size == 'big',
            'w-12 h-20': size == 'small'
        }"
        :style="{ backgroundImage: `url(/img/love-letter/${role}.jpg)` }">
    </div>
</template>
<script>
export default {
    props: {
        role: { type: String, required: true },
        size: { type: String, default: "big" }
    }

}
</script>